import { List } from 'immutable';

import { basicCalculationState } from '../application/common/basicCalculation/state';
import { conditionalState } from '../application/common/createConditional/state';
import { reportHistoryState } from '../application/common/history/state';
import { shareLinkModalState } from '../application/common/modals/components/ShareModal/state';
import { reportState } from '../application/common/report/state';
import { reportConfigurationState } from '../application/common/reportConfiguration/state';
import { reportTargetState } from '../application/common/reportTarget/state';
import { reportTemplateState } from '../application/common/reportTemplate';
import { savedViewState } from '../application/common/savedViews/state';
import { dimensionalTableState } from '../application/dimensionalTable/state';
import { lensState } from '../application/lenses/lensState';
import { reportCreateState } from '../application/reportCreate/state';
import { reportAccessTableState } from '../application/reportExplorer/ReportAccess/state';
import { reportDataTableAgGridState } from '../application/reportExplorer/ReportDataTableAgGrid/state';
import { chartState } from '../application/reportExplorer/ReportVisualization/state';
import { reportExplorerState } from '../application/reportExplorer/state';
import { reportSavedViewEditState } from '../application/reportSavedViewEdit/state';
import { reportUpdateState } from '../application/reportUpdate/state';
import { summaryTableState } from '../application/summaryTable/state';

export const state = List([
  basicCalculationState,
  chartState,
  conditionalState,
  dimensionalTableState,
  reportCreateState,
  reportState,
  reportConfigurationState,
  reportExplorerState,
  savedViewState,
  summaryTableState,
  reportHistoryState,
  reportSavedViewEditState,
  reportUpdateState,
  reportTargetState,
  reportDataTableAgGridState,
  shareLinkModalState,
  lensState,
  reportAccessTableState,
  reportTemplateState
]);

export {
  ReportInitialState,
  reportActionCreators,
  reportActions,
  reportReducer
} from '../application/common/report/state';

export {
  reportExplorerInitialState,
  reportExplorerActionCreators,
  reportExplorerActions,
  reportExplorerReducer
} from '../application/reportExplorer/state';

export {
  ReportConfigurationInitialState,
  reportConfigurationReducer,
  reportConfigurationActions,
  reportConfigurationSelector,
  reportConfigurationActionCreators,
  reportConfigurationStateBranchKey
} from '../application/common/reportConfiguration/state';

export {
  lensInitialState,
  lensActions,
  lensActionCreators,
  lensReducer,
  lensSelector
} from '../application/lenses/lensState';

export {
  reportSavedViewEditActions,
  reportSavedViewEditActionCreators,
  reportSavedViewEditReducer,
  reportSavedViewEditSelector
} from '../application/reportSavedViewEdit/state';

export {
  SavedViewInitialState,
  savedViewActionCreators,
  savedViewActions
} from '../application/common/savedViews/state/savedViewState';

export {
  BasicCalculationInitialState,
  basicCalculationActionCreators,
  basicCalculationReducer
} from '../application/common/basicCalculation/state';

export {
  ReportTargetInitialState,
  reportTargetActionCreators,
  reportTargetReducer
} from '../application/common/reportTarget/state';

export {
  ShareLinkModalInitialState,
  shareLinkActionCreators,
  shareLinkActions,
  shareLinkReducer
} from '../application/common/modals/components/ShareModal/state';

export {
  ReportTemplateInitialState,
  reportTemplateActionCreators,
  reportTemplateActions,
  reportTemplateReducer
} from '../application/common/reportTemplate/reportTemplateState';
